import type { RootState } from '@/store';

export const selectEscritorioList = (state: RootState) => state.escritorioCrud.escritorios;
export const selectEscritorioLoading = (state: RootState) => state.escritorioCrud.isLoading;
export const selectEscritorioError = (state: RootState) => state.escritorioCrud.error;
export const selectEscritorioTotal = (state: RootState) => state.escritorioCrud.total;
export const selectCurrentEscritorio = (state: RootState) => state.escritorioCrud.currentEscritorio;
